var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4844 2.21289H3.51562C1.57711 2.21289 0 3.79 0 5.72852V27.4686C0 29.4071 1.57711 30.9842 3.51562 30.9842H15.3511V35.4386H13.5865C12.9393 35.4386 12.4146 35.9633 12.4146 36.6105C12.4146 37.2577 12.9393 37.7823 13.5865 37.7823H26.4136C27.0608 37.7823 27.5855 37.2577 27.5855 36.6105C27.5855 35.9633 27.0608 35.4386 26.4136 35.4386H24.649V30.9842H36.4844C38.4229 30.9842 40 29.4071 40 27.4686V5.72852C40 3.79 38.4229 2.21289 36.4844 2.21289ZM22.3052 35.4387H17.6948V30.9843H22.3052V35.4387ZM37.6562 27.4687C37.6562 28.1148 37.1305 28.6405 36.4844 28.6405H3.51562C2.86945 28.6405 2.34375 28.1148 2.34375 27.4687V25.6872H37.6562V27.4687ZM37.6562 23.3434H2.34375V5.72852C2.34375 5.08234 2.86945 4.55664 3.51562 4.55664H36.4844C37.1305 4.55664 37.6562 5.08234 37.6562 5.72852V23.3434Z",
    fill: "url(#paint0_linear_1_155)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2402 16.947L11.0658 14.7797L14.2402 12.6125C14.7748 12.2475 14.9123 11.5184 14.5473 10.9839C14.1825 10.4494 13.4533 10.3119 12.9188 10.6768L8.32665 13.8118C8.0068 14.0302 7.81555 14.3925 7.81555 14.7796C7.81555 15.1668 8.0068 15.5293 8.32665 15.7476L12.9188 18.8827C13.1209 19.0207 13.3509 19.0868 13.5784 19.0868C13.9527 19.0868 14.3205 18.9079 14.5473 18.5756C14.9123 18.041 14.7748 17.3119 14.2402 16.947Z",
    fill: "url(#paint1_linear_1_155)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6734 13.8096L27.0812 10.6746C26.5468 10.3097 25.8177 10.4472 25.4527 10.9817C25.0877 11.5162 25.2252 12.2453 25.7598 12.6103L28.9342 14.7775L25.7598 16.9446C25.2252 17.3096 25.0877 18.0387 25.4527 18.5732C25.6796 18.9056 26.0473 19.0845 26.4216 19.0845C26.6491 19.0845 26.8791 19.0183 27.0812 18.8803L31.6734 15.7453C31.9932 15.5269 32.1845 15.1646 32.1845 14.7774C32.1845 14.3903 31.9931 14.0281 31.6734 13.8096Z",
    fill: "url(#paint2_linear_1_155)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9261 9.57047C22.3621 9.25336 21.6475 9.45351 21.3303 10.0178L16.6258 18.3868C16.3088 18.9509 16.509 19.6653 17.0732 19.9825C17.2548 20.0846 17.4519 20.133 17.6464 20.133C18.056 20.133 18.4539 19.9178 18.6689 19.5352L23.3735 11.1662C23.6907 10.6021 23.4903 9.88765 22.9261 9.57047Z",
    fill: "url(#paint3_linear_1_155)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_155",
    x1: 20,
    y1: 2.21289,
    x2: 20,
    y2: 37.7823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FED2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30707"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_155",
    x1: 11.2835,
    y1: 10.4727,
    x2: 11.2835,
    y2: 19.0868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FED2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30707"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_155",
    x1: 28.7165,
    y1: 10.4705,
    x2: 28.7165,
    y2: 19.0845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FED2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30707"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_155",
    x1: 19.9997,
    y1: 9.41992,
    x2: 19.9997,
    y2: 20.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FED2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B30707"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorIcon);
export default __webpack_public_path__ + "static/media/monitorIcon.ce220663ad95b675f4579d3694dd96dc.svg";
export { ForwardRef as ReactComponent };